export enum VisualItemType {
  Button = 'button',
  TextBody = 'textBody',
  Thumbnail = 'thumbnail',
  MetaAction = 'metaAction'
}

export enum ThumbnailType {
  User = 'userThumbnail',
  Game = 'gameThumbnail',
  Group = 'groupThumbnail',
  Asset = 'assetThumbnail',
  Bundle = 'bundleThumbnail',
  Icon = 'icon'
}

export enum ButtonStyle {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Alert = 'Alert',
  Growth = 'Growth'
}

export enum ActionType {
  ReportNotification = 'reportNotification',
  Deeplink = 'deeplink',
  NotificationAPI = 'notificationAPI',
  Dismiss = 'dismiss',
  Reload = 'reload',
  None = 'none'
}

export enum NotificationLayoutType {
  Default = 'Default'
}

export type Action = {
  actionType: ActionType;
  path?: string;
  nextState?: string;
  fallbackState?: string;
};

export type HandleActionCallback = (visualItem: InteractibleVisualItem) => void;

export type HandleEventStreamEventCallback = (
  eventName: string,
  params?: Record<string, string>
) => void;

export type StyleElement = {
  styledElementType: string;
  offset: number;
  length: number;
};

export type StyledText = {
  text: string;
  styledElements?: Array<StyleElement>;
};

export type VisualItemThumbnail = {
  id: string;
  idType: ThumbnailType;
};

export type VisualItemText = {
  title?: StyledText;
  label?: StyledText;
  actions?: Array<Action>;
  eventName?: string;
  clientEventsPayload?: Record<string, string>;
};

export type VisualItemButton = {
  label: StyledText;
  actions: Array<Action>;
  buttonStyle: ButtonStyle;
  eventName?: string;
  clientEventsPayload?: Record<string, string>;
};

export type VisualItemMetaAction = {
  visualItemType: 'MetaAction';
  label: StyledText;
  actions: Array<Action>;
  eventName?: string;
  actionIcon?: string;
  clientEventsPayload?: Record<string, string>;
};

export type InteractibleVisualItem = VisualItemText | VisualItemButton | VisualItemMetaAction;
export type VisualItem = InteractibleVisualItem | VisualItemThumbnail;

export type PageState = {
  layoutKey: NotificationLayoutType;
  visualItems: {
    [VisualItemType.Button]?: Array<VisualItemButton>;
    [VisualItemType.TextBody]?: Array<VisualItemText>;
    [VisualItemType.Thumbnail]?: Array<VisualItemThumbnail>;
    [VisualItemType.MetaAction]?: Array<VisualItemMetaAction>;
  };
};

export type NotificationContent = {
  currentState: string;
  states: { [stateName: string]: PageState };
  minVersion: number;
  timeBeforeRefresh: number;
  notificationType: string;
};

export type NotificationData = {
  id: string;
  notificationSourceType: string;
  eventDate: string;
  isInteracted?: boolean;
  eventCount?: number;
  content: NotificationContent;
};

export type NotificationTemplateProps = {
  currentState: PageState;
  eventTime: string;
  handleActions?: HandleActionCallback;
  handleEventStreamClickEvent: HandleEventStreamEventCallback;
  toggleMetaActions: () => void;
  isMetaActionsOverlay?: boolean;
  isReadOnly?: boolean;
};

export type ButtonRowProps = {
  buttonList: Array<VisualItemButton>;
  handleActions?: HandleActionCallback;
};

export type SendrNotificationProps = {
  notificationData: NotificationData;
};

export type NotificationActionApiResponse = {
  content?: NotificationContent;
};
